/**
 * @module interface
 */
export interface V2TimUserStatus {
    userID?: string;
    statusType?: number;
    customStatus?: string;
}
